module.exports = __webpack_public_path__ + "img/personal_info.9de0289d.svg";